// import dayjs from 'dayjs'; //https://day.js.org/
// import utc from 'dayjs/plugin/utc';
import Util from '@/helper/Utility.js';
import Locale from "@/helper/locale/Locale.js";
import { DateTime } from "luxon"; //https://moment.github.io/luxon

export default {
    /********* Datetime *********
     * @function convertDateToTimeStampUnix
     * @function getTimeZoneOffsetHour
     * @function isDatetimeValid
     * @function cleanTimeFormDatetime
     * @function getEndOfMonth
     * @function getEndOfMonthDay
     * @function getDateByValue
     * @function unixTimestampToDate
     * @function stringToDate
    ****************************/
    /**
     * @param {Date} date
     */
    convertDateToTimeStampUnix: function(date) {
        var unixTime = Math.floor((date.getTime() - date.getTimezoneOffset() * 60 * 1000) / 1000);
        return unixTime;
    },

    mergeDateTimeToDate: function(date,Time) {
        let formatDT = this.dateIsoFormat(date);
        let formatTM = this.timeIsoFormat(Time);
        let dtReady = this.stringToDate(formatDT + " " + formatTM,'yyyy-MM-dd HH:mm');
        return dtReady;
    },

    getTimeZoneOffsetHour: function () {
        let h = new Date().getTimezoneOffset() / 60;
        return h;
    },

    /**
     * @param {number|string} y - A.D. year only, ปี ค.ศ. เท่านั้น (Thai year need to convert before check.)
     * @param {number|string} m - (1 - 12)
     * @param {number|string} d - (1 - 31)
     */
    isDatetimeValid: function(y, m, d) {
        let dt = DateTime.fromObject({ year: y, month: m, day: d });
        return dt.isValid;
    },
    cleanTimeFormDatetime: function(datetime) {
        var date = new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate());
        return date;
    },
    getEndOfMonth: function(year, month) {
        let dt = DateTime.fromObject({ year: year, month: month, day: 1 });
        let end = dt.endOf('month').toJSDate();
        return end;
    },
    getEndOfMonthDay: function (year, month) {
        let lastDate = this.getEndOfMonth(year, month);
        return lastDate.getDate();
    },
    /**
     * @param {string|number} year YYYY
     * @param {string|number} month MM : 1-12
     * @param {string|number} day DD : 1-31
     */
    getDateByValue: function (year, month, day) {
        let dt = DateTime.fromObject({ year: year, month: month, day: day });
        return dt.toJSDate();
    },

    unixTimestampToDate: function (timestamp) {
        if (!Util.isNumber(timestamp) || Util.isEmptyStr(timestamp)) {
            return null;
        }
        let dt = DateTime.fromSeconds(timestamp, { zone: 'utc' });
        // let offset = this.getTimeZoneOffsetHour();
        // dt = dt.plus({ hours: offset });
        dt = dt.plus({ hours: -7 });
        return dt.toJSDate();
    },

    stringToDate: function (string, format) {
        let dt = DateTime.fromFormat(string, format);
        return dt.toJSDate();
    },

    timestampToFormat: function (timestamp, format) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);
        return dt.toFormat(format);
    },

    timestampToFormatAddMinute: function (timestamp, format, minute) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date).plus({ minute: minute });
        return dt.toFormat(format);
    },


    /********** Date Format ***********
     * @function timestampFullFormat
     * @function dateFullFormat
     * @function getDatetimeFullFormat
     * @function getYearByLocale
     * @function timeFormat
     **********************************/

    timestampFullFormat: function (timestamp,addHours) {
        let date = this.unixTimestampToDate(timestamp);
        return this.dateFullFormat(date,addHours);
    },
    dateFullFormat: function (datetime,addHours) {
        let dt = DateTime.fromJSDate(datetime);
        if (addHours) {
            dt = dt.plus({ hours: addHours });
        }

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: "buddhist" })
                .setLocale("th")
                .toFormat('dd MMMM yyyy');
        } else {
            return dt.toFormat('dd MMMM yyyy');
        }
    },
    dateShortFormat: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: "buddhist" })
                .setLocale("th")
                .toFormat('dd MMM yy');
        } else {
            return dt.toFormat('dd MMM yy');
        }
    },
    dateShortFormat2: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: "buddhist" })
                .setLocale("th")
                .toFormat('dd MMM yyyy');
        } else {
            return dt.toFormat('dd MMM yyyy');
        }
    },
    
    getDatetimeShortFormat: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: 'buddhist' })
                .setLocale("th")
                .toFormat('dd MMM yy - HH:mm');
        } else {
            return dt.toFormat('dd MMM yy - HH:mm');
        }
    },
    getDatetimeFullFormat: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: 'buddhist' })
                .setLocale("th")
                .toFormat('dd MMMM yyyy - HH:mm');
        } else {
            return dt.toFormat('dd MMMM yyyy - HH:mm');
        }
    },
    dateIsoFormat: function (datetime) {
        let dt = DateTime.fromJSDate(datetime);
        return dt.toFormat('yyyy-MM-dd');
    },
    getYearByLocale: function(year) {
        if (Locale.getLocaleCode() == 1033) {
            return year;
        }
        return parseInt(year) + 543;
    },
    timeFormat: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);
        return dt.toFormat('HH:mm:ss');
    },
    timeFormatShort: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);
        return dt.toFormat('HH:mm');
    },
    timeFormatShort2: function (timestamp,addHours) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);
        if (addHours) {
            dt = dt.plus({ hours: addHours });
        }
        
        if (Locale.getLocaleCode() == 1033) {
            return dt.toFormat('hh:mm a');
            
        } else {
            return dt.toFormat('HH:mm') + " น.";
        }
    },
    timeIsoFormat: function (datetime) {
        let dt = DateTime.fromJSDate(datetime);
        return dt.toFormat('HH:mm');
    },
    getDatetimeAddSeconds: function(datetime,secAdd) {
        let dt = DateTime.fromJSDate(datetime).plus({ seconds: secAdd });
        return dt.toFormat('HH:mm');
    },

    /********** Date Calculate ***********
     * @function compareYear
     *************************************/

    /**
     * Compare start time + years you need and end date
     * @param {Date} startDate
     * @param {Date} endDate
     * @param {Number} years
     * @returns {Number}
     *  - 0 is equal time
     *  - Positive number is startDate + years is more than endDate (endDate before time)
     *  - Negative number is startDate + years is less than endDate (startDate before time)
     */
    compareYear: function (startDate, endDate, years) {
        let startPlusYears = DateTime.fromJSDate(startDate).plus({ years: years }).toJSDate();
        return startPlusYears.getTime() - endDate.getTime();
    },

    /**
     * Compare date time for pickup
     * @param {DateTime} startDate
     * @param {DateTime} endDate

     * @returns {number}
     *  - 0 is equal time
     */
    compareDetaTimePickup: function (startDate,endDate) {
        let stdt = DateTime.fromJSDate(startDate);
        let endt = DateTime.fromJSDate(endDate);
        let diff = endt.diff(stdt,'minute');
        return diff.toObject().minutes //=> { milliseconds: 2415600000 }
    },

    getDateTimeToTimeStampPickup: function (dateTime) {
        let dt = DateTime.fromJSDate(dateTime);
        let minute = dt.toFormat('mm');

        // minute round up to nearest 10
        let modMinute = minute % 10;
        let diffMinute = 0;

        if (modMinute !== 0) {
            if (minute >= 50) {
                diffMinute = 60 - minute;
            } else if (minute >= 40) {
                diffMinute = 50 - minute;
            } else if (minute >= 30) {
                diffMinute = 40 - minute;
            } else if (minute >= 20) {
                diffMinute = 30 - minute;
            } else if (minute >= 10) {
                diffMinute = 20 - minute;
            } else {
                diffMinute = 10 - minute;
            }
        }
        
        // minute round up to nearest 30
        // if (minute === '00' || minute === 30) {
        //     diffMinute = 0;
        // } else if (minute < 30) {
        //     diffMinute = 30 - minute;
        // } else if (minute > 30) { 
        //     diffMinute = 60 - minute;
        // }
       
        let dtAdd = DateTime.fromJSDate(dateTime).plus({ minute: diffMinute });
        return dtAdd.toJSDate();
    },

    getDateTimeAddMinute: function(dateTime, minute) {
        let dt = null;
        if (dateTime) {
            dt = DateTime.fromJSDate(dateTime).plus({ minute: minute });
        } else {
            dt = DateTime.fromJSDate(new Date()).plus({ minute: minute });
        }
        return dt.toJSDate();
    },
    isBetweenTime: function (startDate,endDate) {
        let dt = DateTime.fromJSDate(new Date())
        let startDateDT = DateTime.fromFormat(dt.toFormat('yyyy-MM-dd') + " " + startDate, 'yyyy-MM-dd HH:mm')
        let endDateDT = DateTime.fromFormat(dt.toFormat('yyyy-MM-dd') + " " + endDate, 'yyyy-MM-dd HH:mm')
    
        if (startDateDT > dt && dt < endDateDT) {
            return true;
        } else {
            return false;
        }
    },
    dateCustomFormat: function (timestamp,addHours, format='dd MMM yyyy') {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (addHours) {
            dt = dt.plus({ hours: addHours });
        }

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: "buddhist" })
                .setLocale("th")
                .toFormat(format);
        } else {
            return dt.toFormat(format);
        }
    },
    timeCustomFormat: function (timestamp,addHours, format={en:'hh:mm',th:'HH:mm'}) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (addHours) {
            dt = dt.plus({ hours: addHours });
        }
        
        if (Locale.getLocaleCode() == 1033) {
            return dt.toFormat(format.en);
            
        } else {
            return dt.toFormat(format.th);
        }
    },
}
